export function metaContent(name) {
  const el = document.querySelector('meta[name="' + name + '"]');
  return el ? el.getAttribute("content") : "";
}
